import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { ITEM_LINE_HEIGHT } from '../../common/constants.tsx';

export const CONTEXT_MENU_PLACEHOLDER_TESTID = 'software-context-menu.ui.menu-renderer-placeholder';

export const SEPARATOR_PLACEHOLDER_HEIGHT = gridSize + 1;
export const SECTION_HEADER_PLACEHOLDER_HEIGHT = gridSize * 2;
export const MENU_ITEM_PLACEHOLDER_HEIGHT = ITEM_LINE_HEIGHT;
